export enum AnalyticsIncomeSources {
  UNREALIZED_GAIN_AND_INCOME = 'Unrealized Gain & Income',
  INCOME_AND_EXPENSE = 'Income & Expense',
  EXCLUDE_TRANSFER = 'Exclude Transfer',
}
